// services/employees.js
import axiosInstance from './axiosInstance';

const EMPLOYEES_API_URL = '/employees';

const employeesService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${EMPLOYEES_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getById(idempresa, idemployee) {
    try {
      const response = await axiosInstance.get(`${EMPLOYEES_API_URL}/getById.php?idempresa=${idempresa}&idemployee=${idemployee}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getTicketsById(idempresa, idemployee) {
    try {
      const response = await axiosInstance.get(`${EMPLOYEES_API_URL}/tickets/getById.php?idempresa=${idempresa}&idemployee=${idemployee}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async getPostos(idempresa, idemployee) {
    try {
      const response = await axiosInstance.get(`${EMPLOYEES_API_URL}/postos/get.php?idempresa=${idempresa}&idemployee=${idemployee}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async set(employeeData) {
    try {
      const response = await axiosInstance.post(`${EMPLOYEES_API_URL}/set.php`, employeeData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async setPhotos(formData) {
    try {
      const response = await axiosInstance.post(`${EMPLOYEES_API_URL}/setPhotos.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, idemployee) {
    try {
      const response = await axiosInstance.get(`${EMPLOYEES_API_URL}/unset.php?idempresa=${idempresa}&idemployee=${idemployee}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async setPostos(postosData) {
    try {
      const response = await axiosInstance.post(`${EMPLOYEES_API_URL}/postos/set.php`, postosData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export default employeesService;
